export default __webpack_public_path__ + "static/media/1s.3f2f60a0.jpg";